import { render, staticRenderFns } from "./BasePress.vue?vue&type=template&id=2286dc7e&"
import script from "./BasePress.vue?vue&type=script&lang=js&"
export * from "./BasePress.vue?vue&type=script&lang=js&"
import style0 from "./BasePress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports